export const APP_AUTH_RETURN_KEY = 'redirect_after_login';

const AUTH_PATHS = new Set(['/login', '/register', '/spotify-auth', '/verify-email', '/password-reset']);

export function internalReturnPath(value: unknown): string | null {
  if (
    typeof value !== 'string' ||
    !value.startsWith('/') ||
    value.startsWith('//') ||
    value.includes('\\') ||
    Array.from(value).some((character) => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127)
  ) {
    return null;
  }
  try {
    const url = new URL(value, window.location.origin);
    const pathname = decodeURIComponent(url.pathname).replace(/\/+$/, '').toLowerCase();
    if (url.origin !== window.location.origin || AUTH_PATHS.has(pathname)) return null;
  } catch {
    return null;
  }
  return value;
}

export function locationReturnPath(location: { pathname: string; search?: string; hash?: string }): string | null {
  return internalReturnPath(`${location.pathname}${location.search || ''}${location.hash || ''}`);
}

export function storedAppReturnPath(): string | null {
  return internalReturnPath(sessionStorage.getItem(APP_AUTH_RETURN_KEY))
    ?? internalReturnPath(localStorage.getItem(APP_AUTH_RETURN_KEY));
}

export function saveAppReturnPath(path: string | null) {
  if (path) {
    sessionStorage.setItem(APP_AUTH_RETURN_KEY, path);
    // Verification emails can open a new tab without the originating session storage.
    localStorage.setItem(APP_AUTH_RETURN_KEY, path);
  } else {
    sessionStorage.removeItem(APP_AUTH_RETURN_KEY);
    localStorage.removeItem(APP_AUTH_RETURN_KEY);
  }
}
